import dayjs, { Dayjs } from 'dayjs';
import { API_DATE_FORMAT } from '../../../utils/date';

export type PeriodPreset = '7d' | '30d' | 'month' | 'year' | 'custom';

export const PERIOD_PRESETS: { value: Exclude<PeriodPreset, 'custom'>; label: string }[] = [
    { value: '7d', label: 'Últimos 7 dias' },
    { value: '30d', label: 'Últimos 30 dias' },
    { value: 'month', label: 'Este mês' },
    { value: 'year', label: 'Este ano' },
];

export const DEFAULT_PRESET: PeriodPreset = '30d';

export interface Period {
    startDate: string;
    endDate: string;
}

// Intervalo de cada atalho, sempre terminando hoje (datas "YYYY-MM-DD")
export function getPresetPeriod(preset: Exclude<PeriodPreset, 'custom'>, now: Dayjs = dayjs()): Period {
    const end = now.startOf('day');
    const start = {
        '7d': end.subtract(6, 'day'),
        '30d': end.subtract(29, 'day'),
        month: end.startOf('month'),
        year: end.startOf('year'),
    }[preset];
    return { startDate: start.format(API_DATE_FORMAT), endDate: end.format(API_DATE_FORMAT) };
}

// Intervalo completo com fim igual ou posterior ao início ("YYYY-MM-DD" compara como texto)
export function isPeriodValid(startDate?: string, endDate?: string): boolean {
    return !!startDate && !!endDate && endDate >= startDate;
}
